import React, { useState } from 'react';
import './pages.css';

// Component to render each expandable section
const ExpandableSection = ({ heading, content }) => {
    const [isOpen, setIsOpen] = useState(false);

    // Toggle function to show/hide content
    const toggleSection = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="section-wrapper">
            <h3 onClick={toggleSection} className="clickableHeading">
                { isOpen ? (
                    <span style={{ textDecoration: "underline" }}>
        {heading}
    </span>
                ) : (
                    heading
                )}



            </h3>
            {!isOpen && (
                <p dangerouslySetInnerHTML={{ __html: content }}></p>
            )}

            <br />
        </div>
    );
};
export default ExpandableSection;
